var map = {
	"./wheel1.png": 68,
	"./wheel1@2x.png": 69
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/wheel1.*\.png$
// module id = 123
// module chunks = d-game